var s = (r, t, o) => new Promise((n, i) => {
  var p = (e) => {
    try {
      a(o.next(e));
    } catch (c) {
      i(c);
    }
  }, l = (e) => {
    try {
      a(o.throw(e));
    } catch (c) {
      i(c);
    }
  }, a = (e) => e.done ? n(e.value) : Promise.resolve(e.value).then(p, l);
  a((o = o.apply(r, t)).next());
});
import { selfAxios as j } from "@oppein/op-utils";
function m(r) {
  return s(this, null, function* () {
    const {
      data: t
    } = yield j.post(
      "/production-order/engineering/bpmSpecialFlow/createDjjSpecialProcess",
      r
    );
    return t;
  });
}
export {
  m as postCreateDjjSpecialProcess
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bpmSpecialFlow/createDjjSpecialProcess/post.js
// module id = 1793
// module chunks = 67